<div class="content-block">
    <div class="dx-card responsive-paddings">

        <div class="content-grid">
            <h2 class="content-block">Account Top-Ups</h2>

            <!-- <dx-data-grid class="dx-card wide-card" [dataSource]="dataSource" [showBorders]="false" [focusedRowEnabled]="true"
        [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true">
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column dataField="Id" caption="Id"> </dxi-column>
        <dxi-column dataField="Created" caption="Date & Time"> </dxi-column>
        <dxi-column dataField="Amount" caption="Amount"> </dxi-column>
        <dxi-column dataField="Description" caption="Description"> </dxi-column>
        <dxi-column dataField="Status" caption="Status"> </dxi-column>
    </dx-data-grid> -->
        </div>

    </div>
</div>